async function getUserData(userData, urls, Formatter, Network) {
  const url = urls.getUserData
  const response = await sendRequest(userData, url, Network)
  const parsedResponse = parseResponse(response, Formatter, Network)
  return parsedResponse
}

async function sendRequest(userData, url, Network) {
  let completedUrl = url + userData.reference
  if(!userData.reference && userData.email){
    completedUrl = `${url}${userData.email}?searchKey=email`
  }

  const header = {
    Authorization: 'Zmz$muQCQJ6rw1BLQQV2WtT#nP80fzlZef7pXAD69P!C',
  }
  const response = await Network.sendGetRequestWithHeader(completedUrl, header)
  return response
}

function parseResponse(response, Formatter, Network) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawUser = response.response.data
    const user = Formatter.parseExternalUser(rawUser)

    return {
      success: true,
      user,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getUserData }
